/*
 * Module for the Replacement Coverages grid partial view on the Insurance Carrier Change job criteria page
 */
rs.module("content/jobs/criteria/insurancecarrierchange/replacementcoveragesgrid",

    [ /* dependencies */ ],

    function () {

        // Initialize the page
        function initialize(lrsGridApi, columnIds) {
            var agGridApi = lrsGridApi.agGridApi;

            if (agGridApi.getDisplayedRowCount() > 0) {

                // automatically open the first row for editing
                agGridApi.startEditingCell({
                    rowIndex: 0,
                    colKey: columnIds.selectedReplacementCoverage
                });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);